import { Box, Grid } from "@mui/material";
import SubscriptionExplorer from "../../components/organisms/subscriptionExplorer/SubscriptionExplorer";

const SubscriptionList = () => {
  return (
    <>
      <Box sx={{ paddingBottom: "10px" }}>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <h1 style={{ textAlign: "left" }}>Subscriptions </h1>
          </Grid>
        </Grid>
      </Box>
      <SubscriptionExplorer />
    </>
  );
};

export default SubscriptionList;
